import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "20",
  fill: "none",
  viewBox: "0 0 15 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.75 0A2.25 2.25 0 0 1 15 2.25v15.5A2.25 2.25 0 0 1 12.75 20H2.25A2.25 2.25 0 0 1 0 17.75V7.621c0-.596.237-1.169.658-1.59L6.026.658C6.448.237 7.021 0 7.618 0zM7.751 5.499a2.25 2.25 0 0 1-2.25 2.252H1.5v9.999c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75V2.25a.75.75 0 0 0-.75-.75H7.748zM7.5 14.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5zm3-3a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5zM2.559 6.251H5.5a.75.75 0 0 0 .75-.751l-.003-2.941z"
    }, null, -1)
  ]))]))
}
export default { render: render }